import React from 'react'
import { Tbody, Td, Th, Thead, Tr,Table } from 'react-super-responsive-table'
import { Card, Container, Row, Spinner } from 'reactstrap'
import useListCreditTransPerProduct from './hooks/useListCreditTransPerProduct'
import ProductTooltip from './ProductTooltip'
import EyeButton from 'pages/Ui/EyeButton/EyeButton'

const ProductWiseCreditUsage = () => {

    // hook
    const{isPending,isSuccess,isError,error,data} = useListCreditTransPerProduct();

    const history = data?.results || [];

    const PRODUCT_INFO = {
        "DA-Basic": "Desktop Appraisal Basic - Automated desktop valuation from property data and comps. Best for quick screening.",
        "DA-Reviewed": "Desktop Appraisal Reviewed - Basic valuation, checked by a licensed appraiser before delivery.",
        "DA-Certified": "Desktop Appraisal Certified - Full desktop appraisal, signed by a licensed appraiser for lending use.",
    };

    const getProductKey = (name = "") => name.split("-").pop().trim().toLowerCase();

  return (
    <Container fluid>
        <Card className='p-4'>
            <div className="pb-2 mb-0">
                <h5 className="fw-bold">Credit Usage by Product</h5>
                <p className='text-muted mb-0' style={{fontSize:'0.7rem'}}>Your pricing and estimated remaining orders</p>
            </div>

            <Row>
                <Table  className='table table-striped table-bordered'>
                    <Thead>
                        <Tr>
                            <Th>Product</Th>
                            <Th>Your Price</Th>
                            <Th>Orders Submitted</Th>
                            <Th>Credits Spent</Th>
                            <Th>Orders Remaining</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            isPending && (
                                <Tr>
                                    <Td colSpan="5" className="text-center">
                                        <Spinner color='primary'/>
                                    </Td>
                                </Tr>
                            )
                        }

                        {
                            isError && (
                                <Tr>
                                    <Td colSpan="18" className="text-center text-danger">
                                        <h6>Error fecthing data: {error.message}</h6>
                                    </Td>
                                </Tr>
                            )
                        }

                        {
                            !isPending && history.length === 0 && (
                                <Tr>
                                    <Td colSpan="18" className="text-center">
                                        <div className='py-4'>
                                            <div className="d-flex flex-column align-items-center text-muted">
                                            <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                                            <h5 className="mb-1">No Data Found</h5>
                                            </div>
                                        </div>
                                    </Td>
                                </Tr>
                            )
                        }

                        {
                            isSuccess && (
                                history.map((his,index)=>(
                                    <Tr key={index}>
                                        {/* <Td>{his.product_name.startsWith('DA') ? his.product_name.replace("DA","Desktop Appraisal") : his.product_name}</Td> */}
                                        <Td>
                                            {his.product_name.startsWith('DA') ? his.product_name.replace("DA","Desktop Appraisal") : his.product_name}
                                            {" "}
                                            {PRODUCT_INFO[his.product_name] && (<EyeButton message={PRODUCT_INFO[his.product_name]}/>)}
                                        </Td>
                                        {/* <Td>
                                            <ProductTooltip
                                                id={`product-${index}`}
                                                text={productDescriptions[his.product_name] || "No description available"}
                                            >
                                                {his.product_name?.startsWith("DA")
                                                    ? his.product_name.replace("DA", "Desktop Appraisal")
                                                    : his.product_name ?? ""}
                                            </ProductTooltip>
                                        </Td> */}
                                        <Td>${Number(his.product_price).toLocaleString('en-us')}</Td>
                                        <Td>{his.total_orders}</Td>
                                        <Td>${Number(his.total_credits).toLocaleString('en-us')}</Td>
                                        <Td>{his.remaining_orders}</Td>
                                    </Tr>
                                ))
                            )
                        }
                    </Tbody>
                </Table>
            </Row>
        </Card>
    </Container>
  )
}

export default ProductWiseCreditUsage